import React                     from 'react';
import classNames                from 'classnames';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  FormView
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import DraggableResizableDialog  from '../ui/DraggableResizableDialog';
import udfsSubscriptionService   from '../services/UdfsSubscriptionService';
// import mainPageModel             from '../main-navigation/MainPageModel';
import scheduleFilterDialogModel from './ScheduleFilterDialogModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  selectMenuPaper: {
    minWidth: '175px !important',
  },
  placeholder: {
    '& input': {
      fontStyle: 'italic',
    },
    '& span > span': {
      fontStyle: 'italic',
    },
  },
  heading: {
    marginLeft: '10px',
    color: 'gray',
  },
});

interface IScheduleFilterDialogProps {
}

type ScheduleFilterDialogProps = WithStyle<ReturnType<typeof styles>, IScheduleFilterDialogProps>;

class ScheduleFilterDialog extends React.PureComponent<ScheduleFilterDialogProps> {
  constructor(props: ScheduleFilterDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    scheduleFilterDialogModel.reset();
  }

  renderPrimaryContents = React.memo((): JSX.Element | null => {
    const { classes }              = this.props;
    const field                    = scheduleFilterDialogModel.form.field;
    const displayPrimaryProperties = field.areas.visible || field.groups.visible || field.occupations.visible || field.assignedEmployees.visible || field.generators.visible;

    if (displayPrimaryProperties) {
      return (
        <>
          <Typography variant='h6' className={classes.heading}>Job Properties</Typography>
          { field.areas.visible             && <div className='content'><field.areas.Editor             className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.groups.visible            && <div className='content'><field.groups.Editor            className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.occupations.visible       && <div className='content'><field.occupations.Editor       className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.assignedEmployees.visible && <div className='content'><field.assignedEmployees.Editor className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.generators.visible        && <div className='content'><field.generators.Editor        className={classNames(classes.placeholder, 'span4')} /></div> }
        </>
      );
    }
    return null;
  });

  renderOtherContents = React.memo((): JSX.Element | null => {
    const { classes }            = this.props;
    const field                  = scheduleFilterDialogModel.form.field;
    const displayOtherProperties = field.employees.visible || field.templates.visible || field.reasons.visible || field.batches.visible || field.levels.visible || field.messageLevels.visible ||
                                   field.inBatch.visible || field.batchStatus.visible || field.timecardStatus.visible || field.timeOffTypes.visible || field.timecardTestStatus.visible ||
                                   field.availableBalance.visible || field.effectiveStart.visible || field.effectiveEnd.visible || field.lastRanAfter.visible || field.tags.visible || field.search.visible ||
                                   udfsSubscriptionService.subscriptionModel.udfs.some(udf => field[udf.name]?.visible);

    if (displayOtherProperties) {
      return (
        <>
          <Typography variant='h6' className={classes.heading}>Other Properties</Typography>
          { field.employees.visible          && <div className='content'><field.employees.Editor          className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.templates.visible          && <div className='content'><field.templates.Editor          className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.reasons.visible            && <div className='content'><field.reasons.Editor            className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.batches.visible            && <div className='content'><field.batches.Editor            className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.levels.visible             && <div className='content'><field.levels.Editor             className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.messageLevels.visible      && <div className='content'><field.messageLevels.Editor      className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.inBatch.visible            && <div className='content'><field.inBatch.Editor            className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.batchStatus.visible        && <div className='content'><field.batchStatus.Editor        className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.timecardStatus.visible     && <div className='content'><field.timecardStatus.Editor     className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.timeOffStatus.visible      && <div className='content'><field.timeOffStatus.Editor      className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.timeOffTypes.visible       && <div className='content'><field.timeOffTypes.Editor       className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.timecardTestStatus.visible && <div className='content'><field.timecardTestStatus.Editor className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.availableBalance.visible   && <div className='content'><field.availableBalance.Editor   className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.effectiveStart.visible     && <div className='content'><field.effectiveStart.Editor     className={classNames(classes.placeholder, 'span1')} />
          { field.effectiveEnd.visible       &&                          <field.effectiveEnd.Editor       className={classNames(classes.placeholder, 'span1')} />}</div> }
          { field.lastRanAfter.visible       && <div className='content'><field.lastRanAfter.Editor       className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.tags.visible               && <div className='content'><field.tags.Editor               className={classNames(classes.placeholder, 'span4')} /></div> }
          { field.search.visible             && <div className='content'><field.search.Editor             className={classNames(classes.placeholder, 'span4')} /></div> }
          { udfsSubscriptionService.subscriptionModel.udfs.map(udf => {
            const UdfEditor = field[udf.name]?.Editor;
            return field[udf.name]?.visible  && <div className='content'><UdfEditor                       className={classNames(classes.placeholder, 'span4')} /></div>;
          })}

        </>
      );
    }
    return null;
  });

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={scheduleFilterDialogModel.form} onSubmit={scheduleFilterDialogModel.actionFn('apply')}>
        <this.renderPrimaryContents />
        <this.renderOtherContents   />
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='sm' DialogProps={{dialog: scheduleFilterDialogModel, actions: ['cancel', 'apply']}} DraggableResizableBoxProps={{minWidth: '345px', minHeight: '480px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IScheduleFilterDialogProps>(styles, ScheduleFilterDialog);
